<template>
    <div id="app">
        <h1>{{name}}</h1>
    </div>
</template>

<script>
export default {
    name: 'Stats',
    data() {
        return {
            name: "Stats"
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Stats.vue